export default {
	appId: '1643355025878301',
}
